export default __webpack_public_path__ + "static/media/video.96ed73c5.jpg";